
import { defineComponent, PropType } from 'vue'
import { store } from '@/store'
import LiveTimer from '@/components/live/LiveTimer.vue'
import LiveControls from '@/components/live/LiveControls.vue'
import { Route, RouteLiveState } from '@/api/tripply/models'

export default defineComponent({
  name: 'LivePanel',
  props: {
    route: {
      type: Object as PropType<Route>,
      required: true
    },
    liveState: {
      type: Object as PropType<RouteLiveState>,
      required: true
    },
    controls: Boolean
  },
  components: { LiveTimer, LiveControls },
  setup(props) {

    return { store }
  }
})
